// inspired by:
// https://usehooks-ts.com/react-hook/use-is-mounted#hook

// For Async function calls, we don't current incorportate abort signals
// or cancellation tokens in Axios. This is a nice second option.
import { useCallback, useEffect, useRef } from 'react';

export const useIsMounted = () => {
  const isMounted = useRef<boolean>(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
};
